import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MenuController, ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

import { UtilitiesService } from '../utilities/utilities.service';
import { AddonModel } from '../models/addon-model';
import { AddonService } from '../services/addon.service';
import { AppSettings } from '../enums/app-settings.enum';
import { ProductService } from '../services/product.service';
import { VerificationComponent } from '../shared/verification/verification.component';
import { AccountService } from '../services/account.service';
import { otpValidation } from '../models/otpValidation.model';
import { AccountListComponent } from '../shared/account-list/account-list.component';
import { GoogleAnalyticsService } from '../services/google-analytics.service';
import { SubjectService } from '../services/subject.service';
import { LanguageSwitchService } from '../services/language-switch.service';
import { TranslateService } from '@ngx-translate/core';
import { SortComponent } from '../shared/sort/sort.component';
import { SkuDataService } from '../services/sku-data.service';
import { FilterDataService } from '../services/filter-data.service';
import { SwiperOptions } from 'swiper';
import { environment } from 'src/environments/environment';
import { CountryListComponent } from '../shared/country-list/country-list.component';
import { AlaphabeticCountryListComponent } from '../shared/alaphabetic-country-list/alaphabetic-country-list.component';
import { RoamingCountriesPartnersComponent } from '../roaming-countries-partners/roaming-countries-partners.component';
import { ApplicationInitializationService } from '../services/application-initialization.service';
//import { PartnerListComponent } from '../shared/';

declare var window: any;
type countryDetail={
  code?: any;
countryName?: any;
id?: any;
image?: any;
links?: any;
nameAr?: any;
roamingCharges?:any;
roamingPartners?:any;
}
@Component({
  selector: 'app-roaming-search',
  templateUrl: './roaming-search.component.html',
  styleUrls: ['./roaming-search.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RoamingSearchComponent implements OnInit {
  @ViewChild('sortedInput', { static: false }) sortedInput: any;
  protected Postpaid: AddonModel = new AddonModel();
  protected Prepaid: AddonModel = new AddonModel();
  protected VistorLine: AddonModel = new AddonModel();
  protected ControlLine: AddonModel = new AddonModel();
  protected eLife: AddonModel = new AddonModel();
  protected TV: AddonModel = new AddonModel();
  protected Calls: AddonModel = new AddonModel();

  public selectedAddon: AddonModel = new AddonModel();
  private orignalSelectedAddon: AddonModel = new AddonModel();
  unsubscribe$: Subject<boolean> = new Subject();
  selectedAddonFiltered: AddonModel = new AddonModel();
  activeAddon: any;
  filtered: boolean = false;
  products: any[] = [];
  isUserLoggedIn: boolean = false;
  otpValidationModel: otpValidation = new otpValidation();
  mobileNumber: any = '';
  userAccounts: any;
  currentAccount: any;
  preferredPartners = [];
  nonPreferredPartners = [];

  addon: any;
  count: any;
  isItemAvailable = false;
  multipleLoggedIn: boolean;
  mAccountNumber: any;
  searchedCountries = [];
  mLang: any;
  posterURL: string;
  posterURLNotFound: boolean;
  oldSkusList: any;
  skus = [];
  segmentList = [];
  selectedSegment = '';
  searchedCountryId: any;
  sorted: any;
  subCategory: any;
  isEmirati: boolean;
  accountList: any;
  tabsURL: any;
  forField="متوفرة لدولة";

  tabsURLNotFound: boolean;
  isArabic: boolean = false;
  sortType: number;
  searched = false;
  GA = { addon: null, impressions: [] };
  switchAccountFlag: boolean = false;
  filteredCount = 0;
  selectedsubCategoryIndex: number;
  filteredItems: any;
  showBackdrop: boolean = false;
  URLS: any;
  countries = [];
  prevent = false;

  frequentlyVisitedStringTemp = [];
  frequentlyVisitedCountries = [];
  ENV: string = '';
  swipeCatConfig: SwiperOptions = {
    breakpoints: {
      // when window width is >= 320px
      1920: {
        slidesPerView: 'auto',
        spaceBetween: 0
      },
    },
  };
  currentLang: any;
  host: string;
  categoryDimension: any;
  selectedCountry: any;
  addOnAvailable = false;
  noCountryFoundError: boolean = false;
  groupCountry: any[] = [];
  countries1: any;
  selectedCountryName: any;
  typedValue = '';
  searchedVal: any;
  initialVal = 'cat1590026';
  categoryIdForRoamingAddons = 'cat1590026';
  countriesList: { links: any[]; countries: { image: string; roamingPartners: any[]; nameAr: string; code: string; id: string; countryName: string; }[]; };
  ROAMING_MUST_KNOW: string;
  countryImage = '';
  arabicStringList: any[];
  arabicListSorted: any[];
  isFilter = false;
  sameFilterSearch: boolean;
  categories_addon: any[];
  roamingCharges: any;
  constructor(
    private ADDS: AddonService,
    private UTS: UtilitiesService,
    private PS: ProductService,
    private AS: AccountService,
    private menu: MenuController,
    private aRoute: ActivatedRoute,
    private modalController: ModalController,
    private GAS: GoogleAnalyticsService,
    private SS: SubjectService,
    private cdr: ChangeDetectorRef,
    private LSS: LanguageSwitchService,
    private router: Router,
    private route: ActivatedRoute,

    private translate: TranslateService,
    private SKUDS: SkuDataService,
    private FDS: FilterDataService,
    private appInitializationService: ApplicationInitializationService
  ) {
    this.frequentlyVisitedStringTemp = this.appInitializationService.environmentConfig.ROAMING_FREQUENTRLY_VISITED_COUNTRIES;

    localStorage.removeItem('subCategoryId');
    this.host = environment.HOST;
    this.SS.selectedFilter.subscribe((data: any) => {
      
      if (data && data.NS) {
        this.showBackdrop = false;
        const NS = data.NS;
        this.filteredCount = data.C;
        if (NS == AppSettings.RESET_FILTER) {
          this.resetFilteredProducts();
        } else if (this.filteredCount > 1) {
          const SF = data.SF;
        } else {
          this.filteredProducts(NS);
        }
      }
    });
    this.SS.selectedSort.subscribe((sort) => {
      if (sort) {
        this.sorted = sort;
        this.selectSortedItem(sort);
        setTimeout(() => {
          this.cdr.detectChanges();
        }, 500);
      }
    });
    this.SS.selectedAccount.subscribe((r) => {
      if (r) {
        this.currentAccount = r;
        this.SS.currentAccount.next(this.currentAccount);
        this.switchAccountFlag = false;
        this.cdr.detectChanges();
        this.getMyAddonsCategory(this.currentAccount.planCategory);
      }
    });
    this.currentLang = this.UTS.getLocaleLanguage().toLowerCase();

  }


  check(e:any) {
    const event = e?.target?.value;
    this.isFilter = false;
    this.sameFilterSearch=false;
    if(this.sameFilterSearch==false)
    {
      this.SS.selectedFilter.next({
        NS: AppSettings.RESET_FILTER,
        C: 0,
        SF: null,
      });
    
      this.resetExistingFilter(this.selectedAddon.filters)

    }
    if (this.currentLang == 'ar') {
      let country = this.countries.filter(x => x.nameAr == event.target.value.toLowerCase() || x.nameAr == event.target.value.toUpperCase());
      if(country?.length > 0)
        this.checkPackagesByCountry(country[0]);
    } else {
      let country = this.countries.filter(x => x.countryName == event.target.value.toLowerCase() || x.countryName == event.target.value.toUpperCase());
      if(country?.length > 0)
        this.checkPackagesByCountry(country[0]);
    }

  }
  checkByName(name) {
    this.isFilter = false;
    this.sameFilterSearch=false;
    let country:countryDetail = this.countries.filter(x => x.countryName.toLowerCase() == name.toLowerCase() )[0];
    if (this.currentLang == 'ar') {
      this.selectedCountryName = country?.nameAr;
    } else {
      this.selectedCountryName = country?.countryName;
    }
    if(this.sameFilterSearch==false)
    {
      this.SS.selectedFilter.next({
        NS: AppSettings.RESET_FILTER,
        C: 0,
        SF: null,
      });
    
      this.resetExistingFilter(this.selectedAddon.filters)

    }
  
    this.checkPackagesByCountry(country);
  }

  ngOnInit() {
    this.getNAVURLs();
    this.setCMSURLs();
    this.getRoamingCountriesList();
  }
  afterSearch(country) {
    this.isFilter = false;
    this.sameFilterSearch=false;
    if (this.currentLang == 'ar') {
      this.selectedCountryName = country?.nameAr;
    } else {
      this.selectedCountryName = country?.countryName;
    }
    if(this.sameFilterSearch==false)
    {
      this.SS.selectedFilter.next({
        NS: AppSettings.RESET_FILTER,
        C: 0,
        SF: null,
      });
    
      this.resetExistingFilter(this.selectedAddon.filters)

    }
    this.checkPackagesByCountry(country)
  }
  configureFrequentlyVisited() {
    this.frequentlyVisitedStringTemp.forEach(ele => {
      let country = this.countries.filter(x => x.countryName.toLowerCase() == ele.toLowerCase());
      if(country?.length > 0)
        this.frequentlyVisitedCountries.push(country[0]);
    })
  }
  setCMSURLs() {
    this.route.queryParamMap.subscribe((params) => {
      const token: any = { ...params };
      if (token.params.hasOwnProperty('locale') && token.params.locale=='ar') {
        this.ROAMING_MUST_KNOW = token.params.locale + AppSettings.ROAMING_NEED_TO_KNOW;

      }
      else{
        this.ROAMING_MUST_KNOW = 'en' + AppSettings.ROAMING_NEED_TO_KNOW;
      }
    
      
      if (this.currentLang === 'ar' ) {
        this.URLS = {
          APPLICATION_HEADER_URL: 'ar' + AppSettings.APPLICATION_HEADER_URL,
          APPLICATION_FOOTER_URL: 'ar' + AppSettings.APPLICATION_FOOTER_URL,
          APPLICATION_NAVIATION_URL:
            'ar' + AppSettings.APPLICATION_NAVIATION_URL,
          APPLICATION_QLINKS_FOOTER_URL:
            'ar' + AppSettings.APPLICATION_QLINKS_FOOTER_URL,
          APPLICATION_FAQ_URL: 'ar' + AppSettings.FAQ_URL,
          POSTPAID_MIGRATION_BANNER: 'ar' + AppSettings.POSTPAID_MIGRATION_BANNER
        };
      } else {
        this.URLS = {
          APPLICATION_HEADER_URL: 'en' + AppSettings.APPLICATION_HEADER_URL,
          APPLICATION_FOOTER_URL: 'en' + AppSettings.APPLICATION_FOOTER_URL,
          APPLICATION_NAVIATION_URL:
            'en' + AppSettings.APPLICATION_NAVIATION_URL,
          APPLICATION_QLINKS_FOOTER_URL:
            'en' + AppSettings.APPLICATION_QLINKS_FOOTER_URL,
          APPLICATION_FAQ_URL: 'en' + AppSettings.FAQ_URL,
          POSTPAID_MIGRATION_BANNER: 'en' + AppSettings.POSTPAID_MIGRATION_BANNER
        };
      }

    })
  }
  ngAfterContentInit() { }

  getNAVURLs() {
    this.route.queryParamMap.subscribe((params) => {
      const token: any = { ...params };
      const parentLanguage = localStorage.getItem('curr_language');
      const parentLang = parentLanguage
        ? parentLanguage.toLocaleLowerCase()
        : 'english';
      localStorage.removeItem('language');
      const localLanguage = localStorage.getItem('language');
      const lang = token.params.locale
        ? token.params.locale.toLowerCase()
        : token.params.lang
          ? token.params.lang.toLowerCase()
          : localLanguage
            ? localLanguage.toLocaleLowerCase()
            : 'en';

      if (lang === 'ar' || parentLang === 'arabic') {
        this.URLS = {
          APPLICATION_HEADER_URL: 'ar' + AppSettings.APPLICATION_HEADER_URL,
          APPLICATION_FOOTER_URL: 'ar' + AppSettings.APPLICATION_FOOTER_URL,
          APPLICATION_NAVIATION_URL:
            'ar' + AppSettings.APPLICATION_NAVIATION_URL,
          APPLICATION_QLINKS_FOOTER_URL:
            'ar' + AppSettings.APPLICATION_QLINKS_FOOTER_URL,
          APPLICATION_FAQ_URL: 'ar' + AppSettings.FAQ_URL,
          POSTPAID_MIGRATION_BANNER: 'ar' + AppSettings.POSTPAID_MIGRATION_BANNER
        };
      } else {
        this.URLS = {
          APPLICATION_HEADER_URL: 'en' + AppSettings.APPLICATION_HEADER_URL,
          APPLICATION_FOOTER_URL: 'en' + AppSettings.APPLICATION_FOOTER_URL,
          APPLICATION_NAVIATION_URL:
            'en' + AppSettings.APPLICATION_NAVIATION_URL,
          APPLICATION_QLINKS_FOOTER_URL:
            'en' + AppSettings.APPLICATION_QLINKS_FOOTER_URL,
          APPLICATION_FAQ_URL: 'en' + AppSettings.FAQ_URL,
          POSTPAID_MIGRATION_BANNER: 'en' + AppSettings.POSTPAID_MIGRATION_BANNER
        };
      }
    });
  }

  getAddonsByCategories() {
    this.aRoute.params.subscribe((p) => {
      const addon = p && p.id ? p.id : null;
      this.aRoute.queryParams.subscribe((q) => {
        if (q && q.accountNumber) {
          this.mAccountNumber = q.accountNumber;
          this.mLang = q.lang;
          this.UTS.toast(`Account ${this.mAccountNumber} `);
        }
        if (q && q.env) {
          this.UTS.setENV(q.env);
          this.ENV = q.env;
        } else {
          this.ENV = this.UTS.getENV();
        }
        if (q && q['access-token']) {
          this.UTS.setAccessToken(q['access-token']);
        }
        if (q && q['JSESSIONID']) {
          this.UTS.setJSessionID(q['JSESSIONID']);
        }
        //bigIpServer
        if (q && q['bigIpServer']) {
          this.UTS.setBigIpServer(q['bigIpServer']);
        }
        if (
          (q && q.lang && q.lang.toLowerCase() == 'ar') ||
          (q && q.locale && q.locale.toLowerCase() == 'ar')
        ) {
          this.LSS.setLanguage(
            q.locale
              ? q.locale.toLowerCase()
              : q.lang
                ? q.lang.toLowerCase()
                : 'ar'
          );
          this.isArabic = true;
          this.translate.setDefaultLang('ar');
        } else if (
          (q && q.lang && q.lang.toLowerCase() == 'en') ||
          (q && q.locale && q.locale.toLowerCase() == 'en')
        ) {
          this.LSS.setLanguage(
            q.locale
              ? q.locale.toLowerCase()
              : q.lang
                ? q.lang.toLowerCase()
                : 'en'
          );
          this.isArabic = false;
          this.translate.setDefaultLang('en');
        } else {
          this.isArabic = false;
          this.LSS.setLanguage(
            this.UTS.getLocaleLanguage().toLocaleLowerCase()
          );
          this.translate.setDefaultLang('en');
        }

        if (q && q.subCategory) {
          this.subCategory = q.subCategory;
          this.selectedSubCategory();
          if (q && q.categoryDimension) {
            this.categoryDimension = q.categoryDimension;
          }
        } else {
          this.getAccountNoCategoryFound();
        }
      });
    });
  }

  private async selectedSubCategory() {
    this.getAddonsFromAutoSuggest('India', '').then((r) => {
      this.selectedSegment = this.subCategory;
      if (this.subCategory == AppSettings.POSTPAID) this.addon = 'postpaid';
      else if (this.subCategory == AppSettings.PREPAID) this.addon = 'prepaid';
      else if (this.subCategory == AppSettings.CONTROL_LINE)
        this.addon = 'controlline';
      else if (this.subCategory == AppSettings.VISITOR_LINE)
        this.addon = 'visitorline';
      else if (this.subCategory == AppSettings.E_LIFE) this.addon = 'elife';
      else if (this.subCategory == AppSettings.TV) this.addon = 'tv';
      else if (this.subCategory == AppSettings.CALLS) this.addon = 'calls';

      const subCategoryId = localStorage.getItem('subCategoryId');
      if (!subCategoryId) {
        this.page();
        this.bindDataOnSelectedAddon(r);
      }
      if (this.categoryDimension) {
        const categoryId = this.categoryDimension;
        const categories: any[] = this.getSelectedAddonCategories();
        const filterIndex = categories
          .map((x) => x.categoryId)
          .indexOf(categoryId);
        if (filterIndex > -1) {
          this.changeSelectedAddon(categories[filterIndex], filterIndex);
        } else {
          setTimeout(() => {
            this.changeSelectedAddon(categories[0], 0);
          }, 500);
        }
        //&categoryDimension=cat1040018
        localStorage.setItem('subCategoryId', this.categoryDimension);
      } else {
        const categories: any[] = this.getSelectedAddonCategories();
        this.activeAddon = categories[0];
        this.selectedsubCategoryIndex = 0;
      }
    }, error => {
      this.addOnAvailable = false;
    });
  }

  private async filteredProducts(NS: any) {
    this.filtered = true;
    let advanceSearchObject = {
      "No": "0", "Nrpp": "200", "navigationState": NS, "categoryId": this.categoryIdForRoamingAddons,
      "Ntk": 'sku.roamingCountries.countryName', "Ntt": this.selectedCountryName,
      "Ns": "product.isPopular|1||sku.isPopular|1||product.displayOrder|0||sku.displayOrder|0"
    };
    this.getSkusByCountryName(advanceSearchObject);
  }

  private async resetFilteredProducts() {
    this.filtered = false;
    let advanceSearchObject = {
      "No": "0", "Nrpp": "200",  "categoryId": this.categoryIdForRoamingAddons,
      "Ntk": 'sku.roamingCountries.countryName', "Ntt": this.selectedCountryName,
      "Ns": "product.isPopular|1||sku.isPopular|1||product.displayOrder|0||sku.displayOrder|0"
    };
    this.getSkusByCountryName(advanceSearchObject);
    return false;

  }

  private async filteredProductsWithAutoRenewal(SF: any) {
    this.skus = [];
    this.filtered = true;
    let validityData = [];
    let autoRenewalData = [];
    const validity = await SF.find((x) => x.filter_type == 'sku.validityType');
    const autoRenewal = await SF.find(
      (x) => x.filter_type == 'sku.isAutoRenewalFilter'
    );
    let autoRenewalskus = [];
    let validityskus = [];
    if (validity) {
      const NS = validity['navigationState'];
      validityData.push(
        await this.PS.getProductsByCategory(
          this.UTS.getLocaleLanguage(),
          AppSettings.IS_APPLY_DEFAULT_FILTERS,
          null,
          NS,
          AppSettings.NO
        ).toPromise()
      );
      if (validityData && validityData.length > 0) {
        for (let k = 0; k < validityData.length; k++) {
          if (validityData[k].products && validityData[k].products.length > 0) {
            for (let i = 0; i < validityData[k].products.length; i++) {
              if (
                validityData[k].products &&
                validityData[k].products[i] &&
                validityData[k].products[i].skus &&
                validityData[k].products[i].skus.length > 0
              ) {
                for (
                  let j = 0;
                  j < validityData[k].products[i].skus.length;
                  j++
                ) {
                  validityskus.push(validityData[k].products[i].skus[j]);
                }
              }
            }
          }
        }
      }
    }
    if (autoRenewal) {
      const NS = autoRenewal['navigationState'];
      const data = await this.PS.getProductsByCategory(
        this.UTS.getLocaleLanguage(),
        AppSettings.IS_APPLY_DEFAULT_FILTERS,
        null,
        NS,
        AppSettings.NO
      ).toPromise();
      this.filteredItems = data.filters.filter(
        (x: any) => x.dimensionName != 'parentCategory.displayName'
      );
      autoRenewalData.push(data);

      if (autoRenewalData && autoRenewalData.length > 0) {
        for (let k = 0; k < autoRenewalData.length; k++) {
          if (
            autoRenewalData[k].products &&
            autoRenewalData[k].products.length > 0
          ) {
            for (let i = 0; i < autoRenewalData[k].products.length; i++) {
              if (
                autoRenewalData[k].products &&
                autoRenewalData[k].products[i] &&
                autoRenewalData[k].products[i].skus &&
                autoRenewalData[k].products[i].skus.length > 0
              ) {
                for (
                  let j = 0;
                  j < autoRenewalData[k].products[i].skus.length;
                  j++
                ) {
                  autoRenewalskus.push(autoRenewalData[k].products[i].skus[j]);
                }
              }
            }
          }
        }
      }
    }
    for (let i = 0; i < validityskus.length; i++) {
      for (let j = 0; j < autoRenewalskus.length; j++) {
        if (autoRenewalskus[j].skuId == validityskus[i].skuId) {
          this.skus.push(validityskus[i]);
        }
      }
    }
  }

  bindDataOnSelectedAddonFilteredAutoRenewal(data) {
    let skus = [];
    let uniqueSkus = [];
    if (data && data.length > 0) {
      for (let k = 0; k < data.length; k++) {
        if (data[k].products && data[k].products.length > 0) {
          for (let i = 0; i < data[k].products.length; i++) {
            if (
              data[k].products &&
              data[k].products[i] &&
              data[k].products[i].skus &&
              data[k].products[i].skus.length > 0
            ) {
              for (let j = 0; j < data[k].products[i].skus.length; j++) {
                skus.push(data[k].products[i].skus[j]);
              }
            }
          }
        }
      }
    }
    skus = skus.filter((x) => x.isAutoRenewalAvailable);
    uniqueSkus = this.UTS.uniqByKeepLast(skus, (x) => x.skuId);
    this.skus = uniqueSkus;
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  public async openMenu(filter: any[]) {
    this.showBackdrop = true;
    if (this.filtered) {
      this.SS.filteredItemsData.next(this.filteredItems);
    } else {
      filter = await filter.filter(
        (x) => x.dimensionName != 'parentCategory.displayName'
      );
      for (let i = 0; i < filter.length; i++) {
        for (let j = 0; j < filter[i].dimensionValues.length; j++) {
          filter[i].dimensionValues[j]['isSelected'] = false;
        }
      }
      this.FDS.set(filter);
      this.SS.filteredData.next(filter);
    }
    setTimeout(() => {
      this.menu.open();
    }, 500);
  }

  private async bindDataOnSelectedAddon(
    data: any,
    isCategoryChanged?: boolean
  ) {
    this.selectedAddon = new AddonModel();
    this.selectedAddon = data;
    this.orignalSelectedAddon = this.selectedAddon;

    if (!this.sorted) {
      const sorted: any = this.selectedAddon.sortingItems.find((x: any) => {
        return x.name.toLowerCase() == 'new' || x.name == 'الجديد';
      });
      if (sorted && sorted.navigationState) {
        setTimeout(() => {
          this.sorted = sorted;
          this.cdr.detectChanges();
        }, 500);
      }
    }
    this.skus = [];
    if (this.selectedAddon.products && this.selectedAddon.products.length > 0) {
      for (let i = 0; i < this.selectedAddon.products.length; i++) {
        if (
          this.selectedAddon.products &&
          this.selectedAddon.products[i] &&
          this.selectedAddon.products[i].skus &&
          this.selectedAddon.products[i].skus.length > 0
        ) {
          for (let j = 0; j < this.selectedAddon.products[i].skus.length; j++) {
            this.skus.push(this.selectedAddon.products[i].skus[j]);
          }
        }
      }

      setTimeout(() => {
        this.cdr.detectChanges();

      }, 500);
      if (this.sortType == 0) {
        this.sortHighToLow();
      }
      if (this.sortType == 1) {
        this.sortLowToHigh();
      }
    }

    this.count = this.filterCount();
    // this.getBannerImage(this.selectedSegment);
    this.getTabs(this.selectedSegment);
    this.translate.get(['PASSES', 'ADDONS', 'DEALS']).subscribe((r) => {
      this.segmentList = [
        {
          name: r['PASSES'],
          value: 'Passes',
        },
        {
          name: r['ADDONS'],
          value: 'Addons',
        },
        {
          name: r['DEALS'],
          value: 'Deals',
        },
      ];
    });
  }

  private GASKUS() {
    const GASProductImpression = [];
    for (let i = 0; i < this.skus.length; i++) {
      const addon = this.addon ? this.addon : 'My eligible add-ons';
      GASProductImpression.push({
        name: this.skus[i].displayName,
        id: this.skus[i].id
          ? this.skus[i].id
          : this.skus[i].skuId
            ? this.skus[i].skuId
            : '',
        price: this.skus[i].listPrice,
        brand: this.skus[i].brand,
        category: addon,
        list: `${addon}_Add_ons`,
        dimension25: this.activeAddon.value,
        position: i + 1,
      });
    }
    this.impression(GASProductImpression);
  }

  private async bindDataOnSelectedAddonFiltered(
    data: any,
    isCategoryChanged: boolean = false
  ) {
    this.skus = [];

    if (data.products && data.products.length > 0) {
      this.filteredItems = data.filters.filter(
        (x: any) => x.dimensionName != 'parentCategory.displayName'
      );
      for (let i = 0; i < data.products.length; i++) {
        if (
          data.products &&
          data.products[i] &&
          data.products[i].skus &&
          data.products[i].skus.length > 0
        ) {
          for (let j = 0; j < data.products[i].skus.length; j++) {
            this.skus.push(data.products[i].skus[j]);
          }
        }
      }
      if (this.sortType == 0) {
        this.sortHighToLow();
      }
      if (this.sortType == 1) {
        this.sortLowToHigh();
      }
    }

    this.count = this.filterCount();
  }

  sortNew(categoryId, NS) {
    const skus = JSON.parse(JSON.stringify(this.skus));
    let sortedSkus = [];
    this.skus = [];
    this.getSelectedSubCategory(categoryId, NS).then((data) => {
      if (data.products && data.products.length > 0) {
        for (let i = 0; i < data.products.length; i++) {
          if (
            data.products &&
            data.products[i] &&
            data.products[i].skus &&
            data.products[i].skus.length > 0
          ) {
            for (let j = 0; j < data.products[i].skus.length; j++) {
              sortedSkus.push(data.products[i].skus[j]);
            }
          }
        }

        for (let i = 0; i < sortedSkus.length; i++) {
          for (let j = 0; j < skus.length; j++) {
            if (sortedSkus[i]['skuId'] == skus[j]['skuId']) {
              this.skus.push(sortedSkus[i]);
            }
          }
        }
      }
      return false;
    });
  }

  sortPopular(categoryId, NS) {
    const skus = JSON.parse(JSON.stringify(this.skus));
    let sortedSkus = [];
    this.skus = [];
    this.getSelectedSubCategory(categoryId, NS).then((data) => {
      if (data.products && data.products.length > 0) {
        for (let i = 0; i < data.products.length; i++) {
          if (
            data.products &&
            data.products[i] &&
            data.products[i].skus &&
            data.products[i].skus.length > 0
          ) {
            for (let j = 0; j < data.products[i].skus.length; j++) {
              sortedSkus.push(data.products[i].skus[j]);
            }
          }
        }
        for (let i = 0; i < sortedSkus.length; i++) {
          for (let j = 0; j < skus.length; j++) {
            if (sortedSkus[i]['skuId'] == skus[j]['skuId']) {
              this.skus.push(sortedSkus[i]);
            }
          }
        }
      }
      return false;
    });
  }

  sortLowToHigh() {
    this.skus = this.skus.sort(
      (x: any, y: any) => Number(x.listPrice) - Number(y.listPrice)
    );
    this.cdr.detectChanges();
  }

  sortHighToLow() {
    this.skus = this.skus.sort(
      (x: any, y: any) => Number(y.listPrice) - Number(x.listPrice)
    );
    this.cdr.detectChanges();
  }

  private async getBannerImage(id?: string) {
    const res: any = await this.ADDS.bannerImage(id ? id : AppSettings.POSTPAID)
      .toPromise()
      .catch(() => {
        this.posterURLNotFound = true;
      });
    if (res && res.valueAr && res.valueEn) {
      this.posterURLNotFound = false;
      if (this.UTS.getLocaleLanguage().toLowerCase() == 'en') {
        this.posterURL = res.valueEn;
        this.cdr.detectChanges();
      } else {
        this.posterURL = res.valueAr;
      }
    } else {
      // this.getBannerImage(null);
    }
  }

  private async getTabs(id?: string) {
    const res: any = await this.ADDS.getTabs(id ? id : AppSettings.POSTPAID)
      .toPromise()
      .catch(() => {
        this.tabsURLNotFound = true;
      });
    if (res && res.valueAr && res.valueEn) {
      this.tabsURLNotFound = false;
      if (this.UTS.getLocaleLanguage().toLowerCase() == 'en') {
        this.tabsURL = res.valueEn;
      } else {
        this.tabsURL = res.valueAr;
      }
    }
  }

  public getSelectedAddonCategories() {
    if (
      this.selectedAddon &&
      this.selectedAddon.filters &&
      this.selectedAddon.filters.length &&
      this.selectedAddon.filters.length > 0
    ) {
      return this.selectedAddon.filters
        .filter((x: any) => x.dimensionName == 'parentCategory.displayName')
        .map((x: any) => x.dimensionValues)[0];
    }
    return [];
  }

  public getSortingItems() {
    if (this.selectedAddon && this.selectedAddon.sortingItems)
      return this.selectedAddon.sortingItems;
    else return [];
  }
  public async changeSelectedAddon_Roaming(c: any, i?: number, b?:any) {
    this.activeAddon = c;
    this.SS.sku.next({
      value: this.activeAddon,
      name: this.addon,
      id: this.activeAddon.categoryId,
    });
    this.cdr.detectChanges();
   // this.resetFilteredItem();
   this.sameFilterSearch=false;
   if(this.sameFilterSearch==false)
   {
     this.SS.selectedFilter.next({
       NS: AppSettings.RESET_FILTER,
       C: 0,
       SF: null,
     });
   
     this.resetExistingFilter(this.selectedAddon.filters)

   }
    if (i) {
      this.selectedsubCategoryIndex = i;
    }
    this.SKUDS.setSelectedCategory(this.activeAddon);
    this.isFilter = true;
   // this.sameFilterSearch=true;
    let advanceSearchObject = {
      "No": "0", "Nrpp": "200", 
      "navigationState": c.navigationState,
      "categoryId": this.categoryIdForRoamingAddons,
      "Ntk": 'sku.roamingCountries.countryName', "Ntt": this.selectedCountryName,
      "Ns": "product.isPopular|1||sku.isPopular|1||product.displayOrder|0||sku.displayOrder|0"
    };

    this.getSkusByCountryName(advanceSearchObject);
  }
  public async changeSelectedAddon(c: any, i?: number) {
    localStorage.removeItem('subCategoryId');
    if (c && this.activeAddon && c.value == this.activeAddon.value) {
      return false;
    }

    localStorage.setItem('subCategoryId', c.categoryId);
    this.router.navigate([], {
      relativeTo: this.aRoute,
      queryParams: { categoryDimension: c.categoryId },
      queryParamsHandling: 'merge',
    });
    this.activeAddon = c;
    this.SS.sku.next({
      value: this.activeAddon,
      name: this.addon,
      id: this.activeAddon.categoryId,
    });
    this.cdr.detectChanges();
    this.resetFilteredItem();
    if (i) {
      this.selectedsubCategoryIndex = i;
    }
    this.SKUDS.setSelectedCategory(this.activeAddon);
    let NS = c.navigationState ? c.navigationState : '';
    if (NS.includes('&Ns=')) {
      NS = c.navigationState.split('&Ns=')[0];
    }
    this.GAS.category(
      this.addon ? this.addon : 'My eligible add-ons',
      this.activeAddon.value
    );
    if (this.subCategory) {
      const response = await this.getSelectedSubCategory(this.subCategory, NS);
      this.bindDataOnSelectedAddon(response, true);
      this.cdr.detectChanges();
      this.count = this.filterCount();
      this.SS.sku.next({
        value: this.selectedAddon,
        name: this.addon,
        id: this.activeAddon.categoryId,
      });
    }
  }

  private async getSelectedSubCategory(ID: string, NS: string) {
    try {
      const response = await this.PS.getProductsByCategory(
        this.UTS.getLocaleLanguage(),
        AppSettings.IS_APPLY_DEFAULT_FILTERS,
        ID,
        NS,
        AppSettings.NO
      ).toPromise();
      this.addOnAvailable = true;
      return response;
    } catch (e) {
      this.UTS.error(e.message);
      this.addOnAvailable = false;
      return JSON.parse(AppSettings.NO_RECORD_FOUND);
    }
  }

  private async getAddonsFromAutoSuggest(ID: string, NS: string) {

    try {
      const response = await this.PS.getSuggestions(
        { 'Ntt': 'India' }
      ).toPromise();
      this.addOnAvailable = true;
      return response;
    } catch (e) {
      this.UTS.error(e.message);
      this.addOnAvailable = false;
      return JSON.parse(AppSettings.NO_RECORD_FOUND);
    }
  }
  getProducts(products: any) {
    if (products) return products;
    return [];
  }

  getSKUs(skus: any) {
    this.products = [];
    if (this.filtered) {
      if (
        this.selectedAddonFiltered &&
        this.selectedAddonFiltered.products &&
        this.selectedAddonFiltered.products.length > 0
      ) {
        for (let i = 0; i < this.selectedAddonFiltered.products.length; i++) {
          this.products.push(this.selectedAddonFiltered.products[i].skus);
        }
      }
    }
    if (skus && this.filtered == false) {
      if (
        this.selectedAddon &&
        this.selectedAddon.products &&
        this.selectedAddon.products.length > 0
      ) {
        for (let i = 0; i < this.selectedAddon.products.length; i++) {
          if (
            this.selectedAddon.products[i].skus &&
            this.selectedAddon.products[i].skus.length > 0
          ) {
            for (
              let j = 0;
              j < this.selectedAddon.products[i].skus.length;
              j++
            ) {
              this.products[j] = this.selectedAddon.products[i].skus[j];
            }
          }
        }
      }
    }
    return this.products;
  }

  async openBottomSheet() {
    const modal = await this.modalController.create({
      component: VerificationComponent,
      showBackdrop: true,
      backdropDismiss: false,
      cssClass: 'verification-modal modal-fullscreen',
    });
    return await modal.present();
  }

  getMyAddonsCategory(categoryName: string) {
    this.AS.getAccountType(this.currentAccount.accountNo).subscribe(
      (response: any) => {
        if (response && response.emirati) {
          this.isEmirati = response.emirati;
        }
        this.AS.getCategoryInfo({
          categoryName: categoryName,
          isEmirati: this.isEmirati,
        }).subscribe((response: any) => {
          if (response && response.categoryId) {
            this.router.navigateByUrl(
              '/roaming-countries?subCategory=' +
              response.categoryId +
              '&lang=' +
              this.UTS.getLocaleLanguage()
            );
          } else {
            let id = AppSettings.POSTPAID;
            if (this.currentAccount.accountType) {
              if (this.currentAccount.accountType.toLowerCase() == 'prepaid')
                id = AppSettings.PREPAID;
              if (this.currentAccount.accountType.toLowerCase() == 'postpaid')
                id = AppSettings.POSTPAID;
              if (
                this.currentAccount.accountType.toLowerCase() == 'visitorline'
              )
                id = AppSettings.VISITOR_LINE;
              if (
                this.currentAccount.accountType.toLowerCase() == 'controlline'
              )
                id = AppSettings.CONTROL_LINE;
              if (this.currentAccount.accountType.toLowerCase() == 'elife')
                id = AppSettings.E_LIFE;
            }
            this.router.navigateByUrl(
              '/roaming-countries?subCategory=' +
              id +
              '&lang=' +
              this.UTS.getLocaleLanguage()
            );
          }
        });
      }
    );
  }

  getAccount() {
    this.AS.getUserInfo().subscribe(
      (res) => {
        this.AS.getAllAccount().subscribe((resp) => {
          if (resp && resp.userAccounts && resp.userAccounts.length > 0) {
            this.userAccounts = resp.userAccounts;
            if (
              this.userAccounts &&
              this.userAccounts.length &&
              this.userAccounts.length > 1
            ) {
              this.multipleLoggedIn = true;
              this.SS.currentAccount.next(this.currentAccount);
            }
            for (let i = 0; i < resp.userAccounts.length; i++) {
              resp.userAccounts[i]['image'] =
                'data:image/png;base64,' + AppSettings.PROFILE_IMAGE;
            }
            this.accountList = JSON.parse(JSON.stringify(resp.userAccounts));
            for (let i = 0; i < resp.userAccounts.length; i++) {
              if (
                resp.userAccounts[i] &&
                resp.userAccounts[i].primary &&
                resp.userAccounts[i].primary === true
              ) {
                resp.userAccounts[i]['image'] =
                  'data:image/png;base64,' + AppSettings.PROFILE_IMAGE;
                this.currentAccount = resp.userAccounts[i];

                if (!localStorage.getItem('currentAccount')) {
                  this.selectAccount(this.currentAccount);
                }
                this.cdr.detectChanges();
              }
            }
          }

          this.isUserLoggedIn = true;
          if (
            this.userAccounts &&
            this.userAccounts.length &&
            this.userAccounts.length == 1
          ) {
            this.userAccounts[0]['image'] =
              'data:image/png;base64,' + AppSettings.PROFILE_IMAGE;
            this.currentAccount = this.userAccounts[0];
            this.SS.currentAccount.next(this.userAccounts[0]);

            if (!localStorage.getItem('currentAccount')) {
              this.selectAccount(this.currentAccount);
            }
            this.cdr.detectChanges();
          }
          if (localStorage.getItem('switchAccount')) {
            const switchAccount = JSON.parse(
              localStorage.getItem('switchAccount')
            );
            if (localStorage.getItem('currentAccount')) {
              const currentAccount = JSON.parse(
                localStorage.getItem('currentAccount')
              );
              if (currentAccount) {
                this.currentAccount = currentAccount;
                this.cdr.detectChanges();
              }
            }
            if (switchAccount) {
              this.cdr.detectChanges();
              return false;
            }
          }
          if (
            this.isUserLoggedIn == true &&
            this.currentAccount &&
            this.currentAccount.planCategory
          ) {
            this.getMyAddonsCategory(this.currentAccount.planCategory);
          }
          this.AS.getAllAccountIMG().subscribe((resImg: any) => {
            if (
              resImg &&
              resImg.imageBase64Strings &&
              resImg.imageBase64Strings.length &&
              resImg.imageBase64Strings.length > 0
            ) {
              const accountImages = resImg.imageBase64Strings;
              for (let i = 0; i < accountImages.length; i++) {
                if (
                  accountImages[i].accountId == this.currentAccount.accountId &&
                  accountImages[i].image
                ) {
                  this.currentAccount['image'] =
                    'data:image/jpeg;base64,' + accountImages[i].image;
                  this.cdr.detectChanges();
                }
                for (let j = 0; j < this.accountList.length; j++) {
                  if (
                    accountImages[i].accountId ==
                    this.accountList[j].accountId &&
                    accountImages[i].image
                  ) {
                    this.accountList[j]['image'] =
                      'data:image/jpeg;base64,' + accountImages[i].image;
                    this.cdr.detectChanges();
                  }
                }
              }
            }
          });
        });
      },
      (e) => {
        this.aRoute.queryParams.subscribe((q) => {
          if (q && q.subCategory) {
            this.subCategory = q.subCategory;
            if (q && q.categoryDimension) {
              this.categoryDimension = q.categoryDimension;
            }
            this.selectedSegment = this.subCategory;
            localStorage.removeItem('switchAccount');
            localStorage.removeItem('currentAccount');
            this.router.navigateByUrl(
              '/roaming-countries?subCategory=' +
              this.subCategory +
              '&lang=' +
              this.UTS.getLocaleLanguage()
            );
          } else {
            this.selectedSegment = AppSettings.POSTPAID;
            localStorage.removeItem('switchAccount');
            localStorage.removeItem('currentAccount');
            this.router.navigateByUrl(
              '/roaming-countries?subCategory=' +
              AppSettings.POSTPAID +
              '&lang=' +
              this.UTS.getLocaleLanguage()
            );
          }
        });
      }
    );
  }

  getAccountNoCategoryFound() {
    this.AS.getUserInfo().subscribe(
      (res) => {
        this.AS.getAllAccount().subscribe((resp) => {
          if (resp && resp.userAccounts && resp.userAccounts.length > 0) {
            this.userAccounts = resp.userAccounts;
            for (let i = 0; i < resp.userAccounts.length; i++) {
              resp.userAccounts[i]['image'] =
                'data:image/png;base64,' + AppSettings.PROFILE_IMAGE;
            }
            this.accountList = JSON.parse(JSON.stringify(resp.userAccounts));
            for (let i = 0; i < resp.userAccounts.length; i++) {
              if (
                resp.userAccounts[i] &&
                resp.userAccounts[i].primary &&
                resp.userAccounts[i].primary === true
              ) {
                resp.userAccounts[i]['image'] =
                  'data:image/png;base64,' + AppSettings.PROFILE_IMAGE;
                this.currentAccount = resp.userAccounts[i];

                if (!localStorage.getItem('currentAccount')) {
                  this.selectAccount(this.currentAccount);
                }
                this.cdr.detectChanges();
              }
            }
          }

          this.isUserLoggedIn = true;
          if (
            this.userAccounts &&
            this.userAccounts.length &&
            this.userAccounts.length == 1
          ) {
            this.userAccounts[0]['image'] =
              'data:image/png;base64,' + AppSettings.PROFILE_IMAGE;
            this.currentAccount = this.userAccounts[0];
            this.SS.currentAccount.next(this.userAccounts[0]);

            if (!localStorage.getItem('currentAccount')) {
              this.selectAccount(this.currentAccount);
            }
            this.cdr.detectChanges();
          }
          if (localStorage.getItem('switchAccount')) {
            if (localStorage.getItem('currentAccount')) {
              const currentAccount = JSON.parse(
                localStorage.getItem('currentAccount')
              );
              if (currentAccount) {
                this.currentAccount = currentAccount;
                this.cdr.detectChanges();
              }
            }
          }
          if (
            this.isUserLoggedIn == true &&
            this.currentAccount &&
            this.currentAccount.planCategory
          ) {
            this.getMyAddonsCategory(this.currentAccount.planCategory);
          }

          if (
            this.userAccounts &&
            this.userAccounts.length &&
            this.userAccounts.length > 1
          ) {
            this.multipleLoggedIn = true;
            this.SS.currentAccount.next(this.currentAccount);
            this.cdr.detectChanges();
          }

          this.AS.getAllAccountIMG().subscribe((resImg: any) => {
            if (
              resImg &&
              resImg.imageBase64Strings &&
              resImg.imageBase64Strings.length &&
              resImg.imageBase64Strings.length > 0
            ) {
              const accountImages = resImg.imageBase64Strings;
              for (let i = 0; i < accountImages.length; i++) {
                if (
                  accountImages[i].accountId == this.currentAccount.accountId &&
                  accountImages[i].image
                ) {
                  this.currentAccount['image'] =
                    'data:image/jpeg;base64,' + accountImages[i].image;
                  this.cdr.detectChanges();
                }
                for (let j = 0; j < this.accountList.length; j++) {
                  if (
                    accountImages[i].accountId ==
                    this.accountList[j].accountId &&
                    accountImages[i].image
                  ) {
                    this.accountList[j]['image'] =
                      'data:image/jpeg;base64,' + accountImages[i].image;
                    this.cdr.detectChanges();
                  }
                }
              }
            }
          });
        });
      },

      (e) => {
        this.aRoute.queryParams.subscribe((q) => {
          if (q && q.subCategory) {
            this.subCategory = q.subCategory;
            if (q && q.categoryDimension) {
              this.categoryDimension = q.categoryDimension;
            }
            this.selectedSegment = this.subCategory;
            localStorage.removeItem('switchAccount');
            localStorage.removeItem('currentAccount');
            this.router.navigateByUrl(
              '/roaming-countries?subCategory=' +
              this.subCategory +
              '&lang=' +
              this.UTS.getLocaleLanguage()
            );
          } else {
            this.selectedSegment = AppSettings.POSTPAID;
            localStorage.removeItem('switchAccount');
            localStorage.removeItem('currentAccount');
            this.router.navigateByUrl(
              '/roaming-countries?subCategory=' +
              AppSettings.POSTPAID +
              '&lang=' +
              this.UTS.getLocaleLanguage()
            );
          }
        });
      }
    );
  }

  async openAccontsDropdown(ev: any) {
    if (this.multipleLoggedIn == false) return false;
    if (this.accountList && this.accountList.length > 0) {
      const popover = await this.modalController.create({
        component: AccountListComponent,
        cssClass: 'hyb-partail-height-screen-bottom',
        showBackdrop: true,
        componentProps: { userAccounts: this.accountList },
      });
      await popover.present();

      popover.onDidDismiss().then((r) => {
        if (r && r.data && !(r.data?.dismissed == true)) {
          this.currentAccount = r.data;
          this.cdr.detectChanges();
        }
      });
    }
  }

  switchAccount() {
    this.switchAccountFlag = !this.switchAccountFlag;
  }

  changeAccountDesktop(account) {
    this.currentAccount = account;
  }

  filterCount() {
    if (
      this.selectedAddon &&
      this.selectedAddon.filters &&
      this.selectedAddon.filters.length > 0
    ) {
      const filter: any = this.selectedAddon.filters.find(
        (x: any) => x.dimensionName != 'parentCategory.displayName'
      );
      let count = this.selectedAddon.filters
        .filter((x: any) => x.dimensionName != 'parentCategory.displayName')
        .map((x: any) => x.dimensionValues);

      count = [].concat(...count);
      if (count && count.length > 0) {
        return count.length;
      }
      if (filter && filter.refinementsCount) {
        return filter.refinementsCount;
      }
      return 0;
    }
    return 0;
  }

  private resetFilteredItem() {
    this.sortType = -1;
    this.filteredCount = 0;
    this.filtered = false;
    this.sorted = null;
    this.selectedsubCategoryIndex = null;
    this.SS.resetFilter.next(true);
  }

  segmentChanged(e) {
    const OS = this.UTS.getMobileOperatingSystem();
    if (this.ENV == 'mobile' && OS == 'Android') {
      if (e.target.value == 'Passes') {
        window.caramel.goToNewScreen();
      } else if (e.target.value == 'Deals') {
        window.deals.goToNewScreen();
      }
    } else if (this.ENV == 'mobile' && OS == 'iOS') {
      if (e.target.value == 'Passes') {
        (window as any).webkit.messageHandlers.hybridInterface.postMessage(
          'caramel'
        );
      } else if (e.target.value == 'Deals') {
        (window as any).webkit.messageHandlers.hybridInterface.postMessage(
          'deals'
        );
      }
    }
  }

  selectSortedItem(e) {
    if (e) {
      this.sortType = -1;
      const NS = e.navigationState;
      const categoryId = null;
      const name = e.name;
      this.GAS.sort(name || NS, this.selectedAddon?.breadCrumbs?.label);
      if (
        (name && name.toLowerCase().includes('high to low')) ||
        (name && name.includes('من الأكثر للأقل'))
      ) {
        this.sortType = 0;
      }
      if (
        (name && name.toLowerCase().includes('low to high')) ||
        (name && name.includes('من الأقل للأكثر'))
      ) {
        this.sortType = 1;
      }
      if (
        (name && name.toLowerCase().includes('new')) ||
        (name && name.includes('الجديد'))
      ) {
        this.sortType = 2;
      }
      if (
        (name && name.toLowerCase().includes('popular')) ||
        (name && name.includes('الأكثر رواجًا'))
      ) {
        this.sortType = 3;
      }
      if (this.filtered) {
        if (this.sortType == 0) {
          this.sortHighToLow();
        }
        if (this.sortType == 1) {
          this.sortLowToHigh();
        }
        if (this.sortType == 2) {
          this.sortNew(categoryId, NS);
        }
        if (this.sortType == 3) {
          this.sortPopular(categoryId, NS);
        }
      } else {
        if (e.navigationState) {
          this.getSelectedSubCategory(categoryId, NS).then((r) => {
            this.bindDataOnSelectedAddon(r, true);
            return false;
          });
        }
      }
    }
  }

  public impression(impressions) {
    if (
      this.GA &&
      this.GA.impressions &&
      impressions &&
      this.GA.impressions.length == impressions.length
    )
      return false;
    this.GAS.productImpressions(impressions);
    this.GA.impressions = impressions;
  }

  public page() {
    if (this.GA && this.GA.addon && this.GA.addon == this.addon) return false;
    this.GAS.page(this.addon ? this.addon : 'My eligible add-ons');
    this.GA.addon = this.addon;
  }

  public async sortModal() {
    const modal = await this.modalController.create({
      component: SortComponent,
      showBackdrop: true,
      cssClass: 'hyb-partail-height-screen',
      componentProps: {
        sorts: this.getSortingItems(),
        sorted: this.sorted,
      },
    });
    return await modal.present();
  }

  selectAccount(ua: any) {
    localStorage.removeItem('subCategoryId');
    localStorage.setItem('switchAccount', 'true');
    localStorage.setItem('currentAccount', JSON.stringify(ua));
    this.resetFilteredItem();
    setTimeout(() => {
      this.SS.selectedAccount.next(ua);
    }, 500);
  }

  gotoCart() {
    const OS = this.UTS.getMobileOperatingSystem();
    if (this.ENV == 'mobile' && OS == 'Android') {
      window.deals.goToCartScreen();
    } else if (this.ENV == 'mobile' && OS == 'iOS') {
      (window as any).webkit.messageHandlers.hybridInterface.postMessage(
        'cart'
      );
    }
  }
  async getItems(event) {
    this.typedValue = event.srcElement.value;
    
   
    if (!this.typedValue) {
      this.typedValue = '';
      return;
    }
    let val = this.typedValue;
    if (val && val.trim() !== '') {
      this.isItemAvailable = true;

      if (this.currentLang == 'ar') {
        let temp = this.countries.filter(res => res.nameAr[0] == this.typedValue[0]);
        this.searchedCountries = temp.filter((item) => {
          return (item.nameAr.toLowerCase().includes(val.toLowerCase()));

        });
      } else {
        let temp = this.countries.filter(res => res.countryName[0] == this.typedValue[0].toLowerCase() || res.countryName[0] == this.typedValue[0].toUpperCase());
        this.searchedCountries = temp.filter((item) => {

          return ((item.countryName.toLowerCase().includes(val.toLowerCase()) || item.countryName.toUpperCase().includes(val.toUpperCase())))
        });
      }
    } else {
      this.isItemAvailable = false;
      this.searchedCountries = [{ countryName: 'No Countries Found', categoryId: '', nameAr: 'No Countries Found' }];
    }
    if (this.searchedCountries.length == 0) {
      this.searchedCountries = [{ countryName: 'No Countries Found', categoryId: '', nameAr: 'No Countries Found' }];
    }
  }
  onClear() {
    this.isItemAvailable = false;
    this.searchedCountries = [];
    this.skus = [];
    this.preferredPartners = [];
    this.nonPreferredPartners = [];
    this.addOnAvailable = false;
    this.typedValue = "";
    this.noCountryFoundError=false;
  }
  checkPackagesByCountry(country) {

    if (this.currentLang == 'ar') {
      this.selectedCountryName = country?.nameAr;
    } else {
      this.selectedCountryName = country?.countryName;
    }
    this.onCountrySelectGA(this.selectedCountryName);
    this.addOnAvailable = false;
    this.prevent = true;
    if (this.countries.findIndex(x => x.countryName == country.countryName) > -1) {
      this.searched = true;
      if (this.isFilter == false) {
        this.categoryIdForRoamingAddons = this.initialVal;
      }

      let advanceSearchObject = {
        "No": "0", "Nrpp": "200",  "categoryId": this.categoryIdForRoamingAddons,
        "Ntk": 'sku.roamingCountries.countryName', "Ntt": this.selectedCountryName, 
        "Ns": "product.isPopular|1||sku.isPopular|1||product.displayOrder|0||sku.displayOrder|0"
      };
      this.selectedCountry = country;
      this.isItemAvailable = false;
      this.searchedCountries = [];
   
      this.typedValue = "";
      this.searchedCountryId = country?.id;

     

      this.getRoamingCountries(country?.id);
      this.getSkusByCountryName(advanceSearchObject);
    } else {
      this.noCountryFoundError = true;

    }

  }
  async resetExistingFilter(filter)
  {
    this.resetFilteredItem();
    this.filtered = false;
    filter = await filter.filter(
      (x) => x.dimensionName != 'parentCategory.displayName'
    );
    for (let i = 0; i < filter.length; i++) {
      for (let j = 0; j < filter[i].dimensionValues.length; j++) {
        filter[i].dimensionValues[j]['isSelected'] = false;
      }
    }
    this.FDS.set(filter);
    this.SS.filteredData.next(filter);    
  }
  onCountrySelectGA(countryName) {
    let modal_data = {
      event: 'b2b_fire_event',
      eventCategory: 'roaming',
      eventAction: 'Select a country to view roaming packs and tariffs',
      eventLabel: countryName,
      user_env: this.UTS.getENV()
    }
    this.GAS.countrySearch_Roaming(modal_data);
  }
  typed(event) {
    this.typedValue = event.detail.value;
  }
  openPartners(id) {
    this.openBottomSheets1(RoamingCountriesPartnersComponent, { id: id, lang: this.currentLang }, 'verification-modal eand-radius-modal eand-partail-height-screen-bottom-90 eand-partail-height-screen-bottom-mobile');
  }
  openAllCountry() {
    this.openBottomSheets(AlaphabeticCountryListComponent, { country: this.groupCountry, lang: this.currentLang }, 'verification-modal eand-radius-modal eand-partail-height-screen-bottom-90 eand-partail-height-screen-bottom-mobile');
  }

  getSkusByCountryName(obj) {
    this.PS.getSkuByCountryName(obj, 1, this.currentLang).subscribe((res: any) => {

      if (res.products.length > 0) {
        this.noCountryFoundError = false;
        this.addOnAvailable = true;

        this.bindDataOnSelectedAddon(res);
         
        const categories: any[] = this.getSelectedAddonCategories();
        this.categories_addon=categories;
        if (!this.activeAddon && categories.length > 0) {
          this.activeAddon = categories[0];
        }
        this.selectedsubCategoryIndex = 0;
        this.count = this.filterCount();
        this.cdr.detectChanges();
        this.productImpressionsOnSearch();
      
      }
      else {
        this.noCountryFoundError = true;
      }

    }, err => {
      this.noCountryFoundError = true;
    })
  }

  productImpressionsOnSearch() {
    let productImpressionArray = [];
    let index = 0;
    this.skus.forEach(ele => {

      productImpressionArray.push({
        name: ele.displayName,
        id: ele.skuId,
        price: +ele.listPrice,
        brand: ele.brand,
        category: 'Roaming',
        variant: '',
        list: 'Search Results',
        user_env: this.UTS.getENV(),
        position: index + 1
      })
      index++;
    })
    let data_modal = {
      event: 'productImpressions',
      user_env: this.UTS.getENV(),
      ecommerce: {
        currencyCode: 'AED',
        impressions: productImpressionArray
      }
    }
    this.GAS.productImpressionsOnSearch_Roaming(data_modal);
  }

  extractSKU(records) {

    records.forEach(element => {
      let bestSell = element.attributes['product.sellable'] !== undefined ? element.attributes['product.sellable'][0] : '';
      let brand = 'Etisalat';
      let description = element.attributes['product.description'] !== undefined ? element.attributes['product.description'][0] : '';
      let displayName = element.attributes['product.displayName'] !== undefined ? element.attributes['product.displayName'][0] : '';
      let longDescription = element.attributes['sku.longDescription'] !== undefined ? element.attributes['sku.longDescription'][0] : '';
      let listPrice = element.attributes['product.listPriceAll'] !== undefined ? element.attributes['product.listPriceAll'][0] : '';
      let type = element.attributes['sku.type'] !== undefined ? element.attributes['sku.type'][0] : '';
      let validityType = '30 days';
      let isNew = element.attributes['product.isNew'] !== undefined ? element.attributes['product.isNew'][0] : '';
      let skuId = element.attributes['record.id'] !== undefined ? element.attributes['record.id'][0].split('-')[1].split('.')[0] : '';
      let recurringPrice = element.attributes['sku.activePrice'] !== undefined ? element.attributes['sku.activePrice'][0] : '';
      this.skus.push({
        bestSell: bestSell,
        brand: brand,
        description: description,
        displayName: displayName,
        longDescription: longDescription,
        listPrice: listPrice,
        type: type,
        validityType: validityType,
        isNew: isNew,
        skuId: skuId,
        recurringPrice: recurringPrice


      })
    });
  }
  async openBottomSheets1(component: any, data?: any, classes = 'verification-modal modal-fullscreen eand-radius-modal') {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data },
      cssClass: classes,
    });

    return await modal.present();
  }
  async openBottomSheets(component: any, data?: any, classes = 'verification-modal modal-fullscreen eand-radius-modal') {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data },
      cssClass: classes,
    });
    modal.onDidDismiss().then((data) => {
    });
    return await modal.present();
  }

  getRoamingCountries(code) {
    this.PS.getRoamingCountries(code).subscribe((res: any) => {
     
      this.countryImage = res.image;
      if (res?.roamingPartners != null) {

        this.nonPreferredPartners = res.roamingPartners.filter(x => x.preferred == false);

        this.preferredPartners = res.roamingPartners.filter(x => x.preferred == true);
        this.roamingCharges=res?.roamingCharges;
        
        this.roamingCharges=this.roamingCharges?.substring(1);
      }
    })
  }

  getRoamingCountriesList() {



    this.PS.getRoamingCountriesList('200001').subscribe((res: any) => {
      this.countries1 = res.countries;
      this.countries = this.countries1.sort((a, b) => a.countryName.toLowerCase().localeCompare(b.countryName.toLowerCase()));
      this.groupCountry = [];
      this.arabicStringList = [];
      this.arabicListSorted = [];
      this.countries.forEach(ele => this.arabicStringList.push(ele.nameAr))
      this.groupCountries();
      this.configureFrequentlyVisited();

    })
  }

  groupCountries() {
    if (this.currentLang == 'en') {
      let data = this.countries1.reduce((r, e) => {
        let group = e && e.countryName[0];
        if (!r[group]) r[group] = { group, countries: [e] }
        else r[group].countries.push(e);
        return r;
      }, {});
      this.groupCountry = Object.values(data);
    }
    else {
      const collator = new Intl.Collator('ar');
      this.arabicListSorted = this.arabicStringList.sort(collator.compare);
      //sort list by arabic name string values;
      let temp = this.arabicListSorted[0];
      this.arabicListSorted.splice(0, 1);
      this.arabicListSorted.splice(127, 0, temp);
      //group objects by strings
      let tempGrouping = [];
      let arr = [];
      this.arabicListSorted.forEach(element => {
        tempGrouping.push(this.countries1.filter(ele => ele.nameAr == element)[0])
      });
      let data = tempGrouping.reduce((r, e) => {
        let group = e && e.nameAr[0];
        if (!r[group]) r[group] = { group, countries: [e] }
        else r[group].countries.push(e);
        return r;
      }, {});
      this.groupCountry = Object.values(data);
      this.groupCountry[15].countries.push(this.groupCountry[18].countries[0]);
      this.groupCountry.splice(18, 1);
    }

  }
  getImage(partner) {
    return partner.image;
  }

  back(){

  }
}